import API from '@/views/Fdc/Apis/'
import _ from 'lodash'
import Dayjs from 'dayjs'

/**
 * Report > Fault Action History
 * Fault Action 이력
 */
export default {
  name: 'FaultActionHistory',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
    /**
     * fromDate 변화 감지
     */
    fromDate () {
      this.toMinDate = this.fromDate
    },
    /**
     * toDate 변화 감지
     */
    toDate () {
      this.fromMaxDate = this.toDate
    }
  },
  beforeMount () {
    this.initColumns()
  },
  methods: {
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * 컬럼 설정
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), field: 'alarmDt', width: 150, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL_NAME'), field: 'modelName', width: 200 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL_TYPE'), field: 'modelType', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ACTION_TYPE'), field: 'actionType', width: 130 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET'), field: 'targetId', width: 130 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LCL'), field: 'lclVal', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.UCL'), field: 'uclVal', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LSL'), field: 'lslVal', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USL'), field: 'uslVal', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_MESSAGE'), field: 'alarmMsg', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.REPLY_MESSAGE'), field: 'replyMsg', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CREATE_DATE'), field: 'createDt', width: 100, type: 'dateTimeColumn' }
      ]
    },
    /**
     * Excel Export
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportExcel () {
      this.$refs.faultActionHistGrid.onClickExportCsv('FaultActionHistory.csv')
    },
    /**
     * Fault Action History 검색
     */
    searchFaultActionHistList () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['MODULE ID']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['MODULE ID']))
        return
      }

      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.getFaultActionHistList(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
    },
    /**
     * Fault Action History 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module Id
     */
    async getFaultActionHistList (fab, eqpId, moduleId) {
      this.rowData = []

      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId,
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999',
        // page 추가 2020.07.01
        page: this.paging.currentPage,
        size: this.paging.size
      }

      let data = await API.FdcAnalysisReport.getFaultActionHistory(payload)

      // console.log({
      //   data,
      //   payload
      // })

      this.rowData = _.clone(data)
      this.paging.total = data.length
      this.paging.totalPage = Math.floor(data.length / this.paging.size)
      this.paging.currentPage = 0

      // this.tempRowData = this.rowData.slice(this.paging.currentPage * this.paging.size, this.paging.currentPage * this.paging.size + this.paging.size)
    },
    /**
     * Fault Action History grid change page event
     * @param {*} page page index
     * @param {*} size page size
     */
    changedPage (page, size) {
      this.paging.currentPage = page
      this.tempRowData = this.rowData.slice(this.paging.currentPage * this.paging.size, this.paging.currentPage * this.paging.size + this.paging.size)
    }
  },
  data () {
    const dateString = new Date().toDateString()
    let fromDt = new Date(Dayjs(dateString).add(-1, 'day').format('YYYY.MM.DD'))
    let toDt = new Date()
    return {
      columns: [],
      rowData: [], // Fault Action History grid row data
      tempRowData: [], // Fault Action History grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색된 EQP Tree node
      fromDate: fromDt, // From Date value
      toDate: toDt, // To Date value
      fromMaxDate: toDt, // From Date Max value
      fromMinDate: null, // From Date Min value
      toMaxDate: toDt, // To Date Max value
      toMinDate: fromDt, // To Date Min value
      paging: {
        type: ['none', 'load-more', 'pagination'][2],
        size: 20, // page per size 설정
        currentPage: 0, // 0으로 초기설정
        totalPage: 1, // 1로 초기설정
        totalElements: 1
      }, // Fault Action History grid pagination option
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }
    }
  }
}
